/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

interface MessageFieldProps {
  onChange: (checked: boolean) => void;
  sendByEmail: boolean;
}

export const DestinationCheckboxFields = (props: MessageFieldProps) => {
  const { sendByEmail, onChange } = props;

  return (
    <>
      <FormGroup check>
        <Input id='send_by_email' type='radio' checked={sendByEmail} className='mr-2' onChange={(e) => onChange(true)} />
        <Label htmlFor='send_by_email'>On platform and email message</Label>
      </FormGroup>
      <FormGroup check>
        <Input id='send_on_platform' type='radio' checked={!sendByEmail} className='mr-2' onChange={(e) => onChange(false)} />
        <Label htmlFor='send_on_platform'>On platform message only</Label>
      </FormGroup>
    </>
  );
}
